import { WelcomeMessageButton } from 'models/digitalMap';
import { useRouter } from 'next/router';
import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface WelcomeMessage {
  text: string;
  buttons: WelcomeMessageButton[];
}

interface ChatAction {
  welcomeMessage: WelcomeMessage;
  selectedButton: string;
}

interface ChatContextType {
  action: ChatAction | null;
  setAction: (action: ChatAction) => void;
  clearAction: () => void;
}

const ChatContext = createContext<ChatContextType | undefined>(undefined);

interface ChatProviderProps {
  children: ReactNode;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({ children }) => {
  const [action, setActionState] = useState<ChatAction | null>(null);

  const setAction = (newAction: ChatAction) => {
    setActionState(newAction);
  };

  const clearAction = () => {
    setActionState(null);
  };

  const router = useRouter();
  const { nav } = router.query;

  React.useEffect(() => {
    // Clear action when navigating away from chat page
    if (nav !== 'svc') {
      setActionState(null);
    }
  }, [nav]);

  return (
    <ChatContext.Provider value={{ action, setAction, clearAction }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = (): ChatContextType | null => {
  const context = useContext(ChatContext);
  if (context === undefined) {
    return null;
  }
  return context;
};
